import BankAccountSelect from "./BankAccountSelect";

export default BankAccountSelect;
